// extracted by mini-css-extract-plugin
module.exports = {"logoPlaceholder":"style__logoPlaceholder__rhuQd","wrapper":"style__wrapper__5wU7Y"};